import axios from "axios";
import { useEffect, useState } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const RED_API = `${BACKEND}/api/red`;
export const TOKEN_KEY = "frenteya_red_token";

export const makeClient = ({ adminKey, token }) =>
  axios.create({
    baseURL: RED_API,
    headers: adminKey ? { "X-Admin-Key": adminKey } : token ? { Authorization: `Bearer ${token}` } : {},
  });

export const errMsg = (e, fallback = "Ocurrió un error. Probá de nuevo.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" · ") || fallback;
  return fallback;
};

export const VIDEO_EXT = ["mp4", "mov"];
export const IMAGE_EXT = ["jpg", "jpeg", "png", "webp"];
export const MAX_MB = { video: 500, imagen: 50 };

export const fileKind = (name = "") => {
  const ext = name.split(".").pop().toLowerCase();
  if (VIDEO_EXT.includes(ext)) return "video";
  if (IMAGE_EXT.includes(ext)) return "imagen";
  return null;
};

export const fmtSize = (b = 0) =>
  b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`;

export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.length === 10 ? `${s}T12:00:00` : s);
  return d.toLocaleDateString("es-AR", { day: "2-digit", month: "short", year: "numeric" });
};

export async function chunkedUpload(client, file, onProgress) {
  const { data } = await client.post("/uploads/init", { filename: file.name, size: file.size });
  const { upload_id, chunk_size } = data;
  const total = Math.ceil(file.size / chunk_size);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunk_size, (i + 1) * chunk_size);
    let tries = 0;
    for (;;) {
      try {
        await client.post(`/uploads/${upload_id}/chunk?index=${i}`, blob, {
          headers: { "Content-Type": "application/octet-stream" },
        });
        break;
      } catch (e) {
        if (++tries >= 3 || (e.response && e.response.status < 500 && e.response.status !== 409)) throw e;
        await new Promise((r) => setTimeout(r, 1500 * tries));
      }
    }
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const res = await client.post(`/uploads/${upload_id}/complete`, null, { timeout: 0 });
  onProgress?.(100);
  return res.data;
}

export const useMeta = () => {
  const [meta, setMeta] = useState({ categorias: [], provincias: [], localidades: [] });
  const reload = () => axios.get(`${RED_API}/meta`).then((r) => setMeta(r.data)).catch(() => {});
  useEffect(() => { reload(); }, []);
  return [meta, reload];
};

export const usePublicRed = () => {
  const [estado, setEstado] = useState({ activa: false, gira: false });
  useEffect(() => { axios.get(`${RED_API}/public/estado`).then((r) => setEstado(r.data)).catch(() => {}); }, []);
  return estado;
};

export const useSignedUrl = (client, fid) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let alive = true;
    setUrl(null);
    if (fid) client.get(`/files/${fid}/link`).then((r) => alive && setUrl(BACKEND + r.data.url)).catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fid]);
  return url;
};

export const triggerDownload = (path) => {
  const a = document.createElement("a");
  a.href = BACKEND + path;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
};
